export const ACTION = {
    MD_ARTICLE_LIST:'MD_ARTICLE_LIST',
    MD_VIDEOS_LIST:'MD_VIDEOS_LIST',
    MD_INTERVIEW_ARTICLE_LIST:'MD_INTERVIEW_ARTICLE_LIST',
    MD_INTERVIEW_VIDEOS_LIST:'MD_INTERVIEW_VIDEOS_LIST',
    MD_DESK_MESSAGE:'MD_DESK_MESSAGE',
    KNOWLEDGE_STACK_LISTING: 'KNOWLEDGE_STACK_LISTING',
    TUESDAY_TALKING_POINTS:'TUESDAY_TALKING_POINTS',
    MF_YEAR_BOOK:'MF_YEAR_BOOK',
    CHART_SCOPE:'CHART_SCOPE',
    GET_MF_INSIGHTS:'GET_MF_INSIGHTS',
    WEEKEND_BYTES: 'WEEKEND_BYTES',
    MARKET_REVIEW: 'MARKET_REVIEW',
    CREDIT_POLICY:'CREDIT_POLICY',
    KNOWLEDGE_STACK_MUSINGS: 'KNOWLEDGE_STACK_MUSINGS',
    KNOWLEDGE_SUBSCRIPTION: 'KNOWLEDGE_SUBSCRIPTION',
    SUBMIT_MD_DESK_EMAIL: 'SUBMIT_MD_DESK_EMAIL',
    KNOWLEDGE_PODCAST: 'KNOWLEDGE_PODCAST',
    KNOWLEDGE_PODCAST_DETAIL: 'KNOWLEDGE_PODCAST_DETAIL',
    MEDIA_HOUSE_VIDEOS_LIST: 'MEDIA_HOUSE_VIDEOS_LIST',
    WEBINAR_LIST: 'WEBINAR_LIST',
    WEBINAR_DETAIL_PAGE: 'WEBINAR_DETAIL_PAGE',
    WEBINAR_REGISTRATION: 'WEBINAR_REGISTRATION',
    SALES_HANDBOOK: 'SALES_HANDBOOK',
    BEHAVIOURAL_BLOGS: 'BEHAVIOURAL_BLOGS',
    GET_MDSPEAK_VIDEO_DETAILS: 'GET_MDSPEAK_VIDEO_DETAILS',
    GET_INTERVIEW_VIDEOS_DETAILS: 'GET_INTERVIEW_VIDEOS_DETAILS',
    MD_APPEND_VIDEOS_LIST: 'MD_APPEND_VIDEOS_LIST',
    MD_APPEND_ARTICLE_LIST: 'MD_APPEND_ARTICLE_LIST',
    MD_APPEND_INTERVIEW_ARTICLE_LIST: 'MD_APPEND_INTERVIEW_ARTICLE_LIST',
};


